import * as React from 'react';
import {toast} from 'react-hot-toast'
import {useState, useContext} from 'react';
import{UserContext} from '../../context/userContext/userContext'
import {useStyle} from '../../context/styleContext/styleContext'
import { ShoppingCartContext } from '../../context/shoppingCartContext/shoppingCartContext';
import { Link, useNavigate } from "react-router-dom";
import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Badge from '@mui/material/Badge';
//import ColorModeIconDropdown from './ColorModeIconDropdown'
//import Sitemark from './SitemarkIcon'
import logoIcon from '../../images/LightIcon.svg'
import shoppingCartIcon from '../../images/shopping_cart.svg'

// const StyledToolbar = styled(Toolbar)(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'space-between',
//   flexShrink: 0,
//   borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
//   backdropFilter: 'blur(24px)',
//   border: '1px solid',
//   //borderColor: (theme.vars || theme).palette.divider,
//   // backgroundColor: theme.vars
//   //   ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
//   //   : alpha(theme.palette.background.default, 0.4),
//   //boxShadow: (theme.vars || theme).shadows[1],
//   padding: '8px 12px',
// }));

export default function Header(){
  const [open, setOpen] = React.useState(false);
  // const toggleDrawer = (newOpen: boolean) => () => {
  //   setOpen(newOpen);
  // };
  const navigate = useNavigate();
  const [toggleDrawer, setToggleDrawer] = useState(false)
  const { style, setStyle } = useStyle();
  const { user, setUser, userEmail, userFirstName, userLastName } = useContext(UserContext);
  const { cartItems, cartSubtotal } = useContext(ShoppingCartContext);
  
  const navToHome = () => {
    setOpen(false)
    navigate('/home');
  };
  const navToMyGear = () => {
    setOpen(false)
    navigate('/my-gear');
  };
  const navToAdmin = () => {
    setOpen(false)
    navigate('/admin');
  };
  const navToTerms = () => {
    navigate('/terms');
  };

  const navToPlugins = () => {
    setOpen(false)
    navigate('/plugins');
  };

  const navToSupport = () => {
    setOpen(false)
    navigate('/support');
  };

  const navToPrivacyPolicy = () => {
    navigate('/privacy-policy');
  };

  const navToRegister = () => {
    setOpen(false)
    navigate('/register')
  }

  const navToLogin = () => {
    setOpen(false)
    navigate('/login')
  }

  const navToAccount = () => {
    setOpen(false)
    navigate('/account')
  }

  const logout = () => {
    
    localStorage.removeItem('token')
    setUser(null)
    setOpen(false)
    toast.success("Logout successful");
    //navigate('/login')
  }

  const setDrawerToggleFalse = async (e) => {
    e.preventDefault();
    setOpen(false)
    setToggleDrawer(false);
    }

  const setDrawerToggleTrue = async (e) => {
    e.preventDefault();
    setOpen(true)
    setToggleDrawer(true);
    }


  return (
<div style={{minHeight:'60px', display:'flex'}}>
    <AppBar
      position="fixed"
      enableColorOnDark
      sx={{
        boxShadow: 0,
        bgcolor: style.color1,
        backgroundImage: 'none',
        mt: 'calc(var(--template-frame-height, 0px))',
        minHeight: '60px',
        maxHeight: '60px',
        flex:1
      }}
    >
      <Container maxWidth="lg">
        {/* <StyledToolbar variant="dense" disableGutters> */}
        <Toolbar>
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', px: 0 }}>
            {/* <Sitemark /> */}
            <Button onClick={navToHome} sx={{textTransform:'none', marginLeft:'0px', transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(5)' } }}>
            <div style={{display:'flex', flexDirection:'row'}}>
            <div style={{ display:'flex', width:'50px', height:'50px', marginLeft:'0px'}}>
                <img src={logoIcon} style={{flex:1 }} alt="Parish Audio Logo - a stylized sound wave on a circular background"/>
            </div>
            <div style={{ fontSize:'1.3em', marginLeft:'5px', color:style.color4, alignContent:'center'}}>Parish Audio</div>
            </div>
            </Button>

            <Box sx={{ display: { xs: 'none', md: 'flex', marginLeft:'30px' } }}>
              <Button variant="text" sx={{color:style.color4, boxShadow:3, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(10)' }}} size="medium" onClick={navToHome}>
                Home
              </Button>
              <Button variant="text" sx={{color:style.color4, boxShadow:3, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(10)' }}} size="medium" onClick={navToPlugins}>
                Plugins
              </Button>
              <Button variant="text" sx={{color:style.color4, boxShadow:3, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(10)' }}} size="medium" onClick={navToSupport}>
                Support
              </Button>
              <Button variant="text" sx={{color:style.color4, boxShadow:3, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(10)' }}} size="medium" onClick={navToMyGear}>
                  My Gear
            </Button>
              {user && user.isAdmin && (
                <Button variant="text" sx={{color:style.color4, boxShadow:3, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(10)' }}} size="medium" onClick={navToAdmin}>
                    Admin
                </Button>
              )}
            </Box>
          </Box>
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 1,
              alignItems: 'center',
            }}
          >


        {user && (<>
            <Button variant="text" sx={{color:style.color4, boxShadow:3, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(10)' }}} size="medium" onClick={navToAccount}>
              Account
            </Button>
            <Button variant="text" sx={{color:style.color4, boxShadow:3, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(10)' }}} size="medium" onClick={logout}>
              Logout
            </Button>


          </>)}



        {!user && (<>
            <Button color={style.color4} sx={{ boxShadow:3, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(10)' }}}variant="text" size="small" onClick={navToLogin}>
              Sign in
            </Button>
            <Button color={style.color4} sx={{mr:1, boxShadow:3, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(10)' }}} variant="contained" size="small" onClick={navToRegister}>
              Sign up
            </Button>


          </>)}






            {/* <Button color="primary" variant="text" size="small" onClick={navToLogin}>
              Sign in
            </Button>
            <Button color="primary" variant="contained" size="small" onClick={navToRegister}>
              Sign up
            </Button> */}
            {/* <ColorModeIconDropdown /> */}
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none'}, gap: 1 }}>
            {/* <ColorModeIconDropdown size="medium" /> */}
            <IconButton aria-label="Menu button" onClick={setDrawerToggleTrue} sx={{color:style.color4, size:'large', minWidth:'75px'}}>
              <MenuIcon sx={{size:'large', color:style.color4, fontSize:'24pt'}} />
            </IconButton>
            <Drawer
              anchor="top"
              open={open}
              onClose={setDrawerToggleFalse}
              PaperProps={{
                sx: {
                  top: 'var(--template-frame-height, 0px)'
                },
              }}
            >
              <Box sx={{ p: 2, backgroundColor: style.color4 }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <IconButton onClick={setDrawerToggleFalse}>
                    <CloseRoundedIcon sx={{fontSize:'24pt'}}/>
                  </IconButton>
                </Box>

                <MenuItem onClick={navToHome} sx={{fontSize:'1.3em'}}><strong>Home</strong></MenuItem>
                <Divider sx={{ my: 3 }} />
                <MenuItem onClick={navToPlugins} sx={{fontSize:'1.3em'}}><strong>Plugins</strong></MenuItem>
                <Divider sx={{ my: 3 }} />
                <MenuItem onClick={navToSupport} sx={{fontSize:'1.3em'}}><strong>Support</strong></MenuItem>
                <Divider sx={{ my: 3 }} />
                <MenuItem onClick={navToMyGear} sx={{fontSize:'1.3em'}}><strong>My Gear</strong></MenuItem>
                <Divider sx={{ my: 3 }} />
                {!user &&(<>
                    <MenuItem onClick={navToRegister} sx={{fontSize:'1.3em'}}><strong>Sign Up</strong></MenuItem>
                      <Divider sx={{ my: 3 }} />
                    <MenuItem onClick={navToLogin} sx={{fontSize:'1.3em'}}><strong>Log In</strong></MenuItem>
                  </>
                )}
                {user &&(<>
                  <MenuItem onClick={navToAccount} sx={{fontSize:'1.3em'}}><strong>Account</strong></MenuItem>
                      <Divider sx={{ my: 3 }} />
                    <MenuItem onClick={logout} sx={{fontSize:'1.3em'}}><strong>Log Out</strong></MenuItem>
                
                </>)}

              </Box>
            </Drawer>
          </Box>
          <div style={{maxWidth:'60px'}}>
            <a href='/shopping-cart'>
            <Badge badgeContent={cartItems.length} color='primary' overlap="circular" sx={{ boxShadow:3, transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(1.8)' }}}>
              <img src={shoppingCartIcon} alt="Light blue Shopping Cart icon" style={{width:'30px'}}/>
              </Badge>

            </a>
          </div>
        {/* </StyledToolbar> */}
        </Toolbar>
      </Container>
    </AppBar>
    </div>
  );
}